import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/invoices',
  component: Management,
  redirect: '/invoices/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/invoices/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listInvoices
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/invoices/ListTable'),
          meta: {
            auth: Auth.listInvoices,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/invoices/ListTable'),
          meta: {
            auth: Auth.listInvoices,
            tabName: 'pending'
          }
        },
        {
          path: 'done',
          component: () => import('@/views/invoices/ListTable'),
          meta: {
            auth: Auth.listInvoices,
            tabName: 'done'
          }
        },
        {
          path: 'cancelled',
          component: () => import('@/views/invoices/ListTable'),
          meta: {
            auth: Auth.listInvoices,
            tabName: 'cancelled'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/invoices/DetailLayout'),
      meta: {
        auth: Auth.showInvoice
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/invoices/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showInvoice
          }
        }
      ]
    }
  ]
}
